// extracted by mini-css-extract-plugin
module.exports = {"TaskLogGrid":"TaskLogGridGroup_TaskLogGrid__2DT1N","gridOverlay":"TaskLogGridGroup_gridOverlay__pG4hv","taskModal":"TaskLogGridGroup_taskModal__1cYsV"};